import React from 'react'
import { ReactComponent as Rocket } from '@/shared/assets/desktop/rocket.svg'
import { ReactComponent as Tool } from '@/shared/assets/desktop/tool.svg'
import { ReactComponent as Computer } from '@/shared/assets/desktop/pc.svg'
import { ReactComponent as Planet } from '@/shared/assets/desktop/planet.svg'
import { ReactComponent as YellowGlow } from '@/shared/assets/desktop/yellowGlow.svg'
import { ReactComponent as CheckDecoration } from '@/shared/assets/desktop/checkdecoration.svg'
import middleImg from '@/shared/assets/desktop/MiddleImage.webp'
import cls from './Benefits.module.scss'
import { BGStars } from '@/shared/ui/BGStars/BGStars'
import { classNames } from '@/shared/lib/utils/classNames'
import Marquee from 'react-fast-marquee'
import { useTranslation } from 'react-i18next'

const Benefit = ({ icon, title, description, index, variant, gradient, lang }) => {
    return (
        <article
            style={{ background: gradient }}
            className={classNames(cls.Benefit, [cls['item' + index], cls[variant]])}
        >
            {icon}
            <div className={classNames(cls.title, [cls[variant], cls[lang]])}>
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        </article>
    )
}
export const Benefits = ({ variant = 'default' }) => {
    const { t, i18n } = useTranslation()
    const benefitsList = [
        {
            gradient:
                'radial-gradient(245.99% 119.55% at 5.61% 8.16%, rgba(166, 63, 255, 0.40) 0%, rgba(0, 0, 0, 0.00) 44%), rgba(0, 0, 0, 0.50)',
            icon: <Rocket className={classNames(cls.icon, cls.Rocket)} />,
            title: t('benefits.part1.title'),
            description: t('benefits.part1.description'),
        },
        {
            gradient:
                'radial-gradient(245.99% 119.55% at 5.61% 8.16%, rgba(166, 63, 255, 0.40) 0%, rgba(0, 0, 0, 0.00) 44%), rgba(0, 0, 0, 0.50)',
            icon: <Tool className={classNames(cls.icon, cls.Tool)} />,
            title: t('benefits.part2.title'),
            description: t('benefits.part2.description'),
        },
        {
            gradient:
                'radial-gradient(245.99% 119.55% at 5.61% 8.16%, rgba(166, 63, 255, 0.40) 0%, rgba(0, 0, 0, 0.00) 44%), rgba(0, 0, 0, 0.50)',
            icon: <Computer className={classNames(cls.icon, cls.Computer)} />,
            title: t('benefits.part3.title'),
            description: t('benefits.part3.description'),
        },
    ]
    const marqueeContainer = (item) => {
        return variant === 'default' ? (
            <div className={cls.marqueeWrapper}>
                <Marquee pauseOnHover>{item}</Marquee>
            </div>
        ) : (
            <>{item}</>
        )
    }
    return (
        <div
            id="benefits"
            className={classNames(cls.wrapper, [cls[variant]])}
        >
            <Planet className={cls.planet} />
            <BGStars className={cls.bgstars} />
            {variant === 'distributor' && <YellowGlow className={cls.glow} />}
            <section className={cls.Benefits}>
                <CheckDecoration className={classNames(cls.CheckDecoration, [cls.top, cls[variant]])} />
                <CheckDecoration className={classNames(cls.CheckDecoration, [cls.bottom, cls[variant]])} />
                <h1>{t('benefitTitle')}</h1>
            </section>
            {marqueeContainer(
                <div className={classNames(cls.container, [cls[variant]])}>
                    {benefitsList.map((benefit, index) => (
                        <Benefit
                            lang={i18n.language}
                            variant={variant}
                            key={index}
                            index={index}
                            icon={benefit.icon}
                            title={benefit.title}
                            gradient={benefit.gradient}
                            description={benefit.description}
                        />
                    ))}
                </div>
            )}
            {variant === 'default' && (
                <div className={cls.imgContainer}>
                    <img
                        className={cls.middleImg}
                        src={middleImg}
                        alt=""
                    />
                </div>
            )}
        </div>
    )
}
